import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getCountryDetails = async () => {
    const { path, method } = endpoints.hubs.stats;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}?limit=300`,
            method,
            {},
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
